<template>
  <div id="teacher-education">
    <h4 class="sub-title">Education</h4>
    <div id="education">
      <div class="primary m-2">
        <label for="primary">Did the teacher complete Primary Education?</label>
        <b-form-radio-group name="primary" type="radio" v-model="primary">
          <b-form-radio :value="true">Yes</b-form-radio>
          <b-form-radio :value="false">No</b-form-radio>
        </b-form-radio-group>
      </div>
      <div class="secondary m-2">
        <label for="secondary"
          >Did the teacher complete Secondary Education?</label
        >
        <b-form-radio-group name="secondary" type="radio" v-model="secondary">
          <b-form-radio :value="true">Yes</b-form-radio>
          <b-form-radio :value="false">No</b-form-radio>
        </b-form-radio-group>
      </div>
      <div class="diploma m-2">
        <label for="diploma">Did the teacher receive a Diploma?</label>
        <b-form-radio-group name="diploma" type="radio" v-model="diploma">
          <b-form-radio :value="true">Yes</b-form-radio>
          <b-form-radio :value="false">No</b-form-radio>
        </b-form-radio-group>
      </div>
      <div class="degree m-2">
        <label for="degree">Did the teacher receive a Degree?</label>
        <b-form-radio-group name="degree" type="radio" v-model="degree">
          <b-form-radio :value="true">Yes</b-form-radio>
          <b-form-radio :value="false">No</b-form-radio>
        </b-form-radio-group>
      </div>
      <div class="other m-2">
        <label for="primary"
          >What other education did the teacher complete?</label
        >
        <b-form-textarea
          name="other"
          :rows="3"
          type="text"
          id="other"
          v-model="other"
        ></b-form-textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeacherEducation',
  computed: {
    primary: {
      get() {
        return this.$store.state.teachers.teacher.education_primary;
      },
      set(val) {
        this.$store.commit('teachers/education_primary', val);
      },
    },
    secondary: {
      get() {
        return this.$store.state.teachers.teacher.education_secondary;
      },
      set(val) {
        this.$store.commit('teachers/education_secondary', val);
      },
    },
    diploma: {
      get() {
        return this.$store.state.teachers.teacher.education_diploma;
      },
      set(val) {
        this.$store.commit('teachers/education_diploma', val);
      },
    },
    degree: {
      get() {
        return this.$store.state.teachers.teacher.education_degree;
      },
      set(val) {
        this.$store.commit('teachers/education_degree', val);
      },
    },
    other: {
      get() {
        return this.$store.state.teachers.teacher.education_other;
      },
      set(val) {
        this.$store.commit('teachers/education_other', val);
      },
    },
  },
};
</script>
